import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const EditClaimConfirmation = () => {
  return (
    <div className=" p-8 text-center">
      <h2 className="text-2xl font-semibold mb-4">Thank you</h2>
      <FontAwesomeIcon icon={faCheckCircle} className="text-sas text-6xl mb-4" />

      <p className="text-gray-700 mb-6">
        Thank you for submitting your payment request for consideration
      </p>

      <div className="bg-red-600 text-white text-sm px-4 py-3 rounded-md">
        <p className="font-semibold">Action Required</p>
        <p className="text-xs">
          This payment request requires further information before it can be processed.{' '}
        </p>
      </div>
    </div>
  );
};

export default EditClaimConfirmation;
